import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20b7cc85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Article-main box-style" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content-title" }
const _hoisted_4 = {
  key: 0,
  class: "content-date"
}
const _hoisted_5 = { class: "content-html" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "Article-hot box-style" }

import { reactive, onMounted, ref, nextTick, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getArticleDetail, handleArticleCount as handleArticleCountRes } from '@/apis/frog'
import { useRequest } from '@/util/useLoading'
import { useRtfix } from '@/store'
import Category from '@/components/bussiness/Category/Category.vue'
import ArticleSwitch from './components/ArticleSwitch.vue'
import HotArticles from '@/components/article/HotArticles.vue'
import { getJapanTime as setStationTime } from '@/util/common'
import Marking from './components/Marking.vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const user = computed(() => store.getters.user)
const token = store.getters.token

const htmlArea = ref(null)

const route = useRoute()
const router = useRouter()

const data: any = reactive({
  id: route.params.id,
  type: route.params.type,
  // 文章详情
  detail: {
    createTime: '',
    frogArticleImgUrl: '',
    frogArticleTitle: '',
    frogArticleContent: '',
    viewNum: '0'
  },
  // 文章上一篇下一篇信息
  lastNextMsg: {}
})

onMounted(() => {
  getDetail()
  handleArticleCount()
})

// 监听id改变
watch(() => route.params, (newVal, oldVal) => {
  if (newVal.id === oldVal.id || !newVal.id) {
    return false
  } else {
    data.id = newVal.id
    getDetail()
    handleArticleCount()
  }
})

// 是否查看部分
const markingShow = ref(true)

// 获取详情
const [loading, getDetail] = useRequest(() => {
  const formData = {
    params: {
      frogArticleId: data.id
    }
  }
  return getArticleDetail(formData).then((res: any) => {
    if (res.code === '0') {
      const { noLoginRestriction, noMembershipRestriction } = res.data
      console.log(noLoginRestriction, noMembershipRestriction, user?.value?.membership?.templateLevel)
      if (!token && noLoginRestriction === 3) {
        router.push(useRtfix('kaerumedia'))
        return
      }
      if (noMembershipRestriction === 3) {
        if (!token || !user?.value?.membership?.templateLevel) {
          router.push(useRtfix('kaerumedia'))
          return
        }
        markingShow.value = false
      }
      if (noMembershipRestriction === 2 && user?.value?.membership?.templateLevel > 1) {
        markingShow.value = false
      }
      if (noMembershipRestriction === 1) {
        if (noLoginRestriction === 1) {
          markingShow.value = false
        }
        if (noLoginRestriction === 2 && token) {
          markingShow.value = false
        }
        if (noLoginRestriction === 3) {
          markingShow.value = false
        }
      }
      data.detail = res.data
      nextTick(() => {
        console.log('完成')
        console.log(htmlArea)
        disposeImg()
      })
    }
  })
})

// 处理img标签 给带有data-href的标签添加点击事件跳转
const disposeImg = () => {
  const dom: any = htmlArea.value
  const imgList = dom.getElementsByTagName('img')
  imgList.forEach((item: any) => {
    if (item.dataset.href && item.dataset.href !== '') {
      item.onclick = () => {
        window.open(item.dataset.href)
      }
      item.style.cursor = 'pointer'
    }
  })
}

// 文章累加阅读量
const handleArticleCount = () => {
  const formData = {
    frogArticleId: data.id
  }
  handleArticleCountRes(formData)
}


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Category),
    _createElementVNode("div", {
      class: _normalizeClass({Article: true, viewport: true, readLess: markingShow.value})
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).detail.frogArticleTitle), 1),
          (_unref(data).detail.frogArticleId !== '151')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(setStationTime)(_unref(data).detail.createTime)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              ref: (_value, _refs) => {
                _refs['htmlArea'] = _value
                htmlArea.value = _value
              },
              class: "content-html-area",
              innerHTML: _unref(data).detail.frogArticleContent
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createVNode(ArticleSwitch, {
          id: _unref(data).id,
          type: _unref(data).type
        }, null, 8, ["id", "type"])
      ], 512), [
        [_directive_loading, _unref(loading)]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(HotArticles, { showBtn: false })
      ])
    ], 2),
    (markingShow.value)
      ? (_openBlock(), _createBlock(Marking, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})